export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00155.c03ede5d.png";